module.exports = __webpack_public_path__ + "img/IMG_20190508_141327.015710a1.jpg";